import React, { FC } from 'react';
import { FieldRenderProps } from 'react-final-form';
import { SelectFields } from 'components/forms';
import { checkDisabledRoles, rolesConfig, rolesOptions } from 'constants/roleOptions';

const SelectWithEventsFieldsWrapper: FC<FieldRenderProps<[]>> = (props) => {
  const { children, render, input, ...otherProps } = props;
  return (
    <SelectFields
      options={rolesOptions}
      config={rolesConfig}
      checkDisabled={checkDisabledRoles}
      {...input}
      {...otherProps}
    />
  );
};

export default SelectWithEventsFieldsWrapper;
